import axios from 'axios';

import { getErrorMessage } from '../../../lib/error';

const inviteErrorDetailsToDisplayedMessage: Record<string, string> = {
  'invalid invitee email': 'Invalid email.',
  'invitee is already a member of the team': 'This email is already on the team.',
  'unable to create team invite': 'Unable to send this invite. Please try again.',
  'only a team owner can invite a team owner': 'Only a Team Owner can invite another Team Owner.',
  'team invite has been cancelled': 'This invite has already been cancelled.',
  'team invite has already been used': 'This invite has already been accepted.',
  'team invite has expired': 'This invite has already expired.',
};

export const getInviteErrorMessage = (err: unknown): string => {
  const details = axios.isAxiosError(err) ? err.response?.data?.error?.details : undefined;
  return inviteErrorDetailsToDisplayedMessage[details] ?? getErrorMessage(err);
};
